import {createAsyncThunk} from "@reduxjs/toolkit";
import {handlerError} from "../../../store/thunkHandlers";
import {setModalMessage} from "../../messages/model/slice";
import {backupAPI} from "../api";

export const fetchGetBackups = createAsyncThunk(
    "backup/get_all",
    async (_, {dispatch, rejectWithValue}) => {
        try {
            return await backupAPI.getAll();
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);

export const fetchRunBackup = createAsyncThunk(
    "backup/run",
    async (_, {dispatch, rejectWithValue}) => {
        try {
            await backupAPI.run();
            return await backupAPI.getAll(); // обновляем список после создания
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);

export const fetchRestoreBackup = createAsyncThunk(
    "backup/restore",
    async (key: string, {dispatch, rejectWithValue}) => {
        try {
            const res = await backupAPI.restore(key);
            dispatch(setModalMessage("База данных восстановлена. Рекомендуется перезагрузить приложение."));
            return res.restored;
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);